var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 2C15.028 2 16 2.897 16 4v12c0 1.103-.972 2-2.167 2H5.167C3.972 18 3 17.103 3 16V7h4.333c.6 0 1.084-.447 1.084-1V2h5.416zm-6.5 0v4H3l4.333-4zm1.354 7.75v5.5c0 .416.363.75.813.75.45 0 .813-.334.813-.75v-5.5c0-.416-.363-.75-.813-.75-.45 0-.813.334-.813.75zm-2.979 2v3.5c0 .416.363.75.813.75.45 0 .812-.334.812-.75v-3.5c0-.416-.362-.75-.812-.75-.45 0-.813.334-.813.75zm5.959 2v1.5c0 .416.362.75.812.75.45 0 .813-.334.813-.75v-1.5c0-.416-.363-.75-.813-.75-.45 0-.812.334-.812.75z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default ForwardRef;